import { useEffect, useState } from "react";

const useStudentsReviews = () => {
    const [reviews, setReviews] = useState([]);
    useEffect(()=>{
        fetch('studentsReview.json')
        .then(res => res.json())
        .then(data => setReviews(data)) 
},[])
  
    
    return [reviews, setReviews];
};

export default useStudentsReviews;